import { render, staticRenderFns } from "./UpdateCardModal.vue?vue&type=template&id=edb34cb8&"
import script from "./UpdateCardModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports